import api from '@pray/shared/utils/api';

export async function generateStudyGuide({ artistId = null, contentId = null, locale = null, regenerate = false }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/study-guide`;
  const { data } = await api.executePostRequest(url, { regenerate });

  return data;
}
